// extracted by mini-css-extract-plugin
module.exports = {"createContainer":"send_createContainer__20RjZ","container":"send_container__2YMkj","headerIcon":"send_headerIcon__3H7a8"};